class CartTimerBanner {
  constructor() {
    this.timerElements = null;
    this.duration = null;
    this.endTime = null;
    this.interval = null;
    this.storageKey = 'cartTimerEndTime';

    this.reinitialize();
    

    if (!this.timerElements || this.timerElements.length === 0) {
      this.watchForTimerElements();
    }
  }
  
  watchForTimerElements() {

    const checkInterval = setInterval(() => {
      const elements = document.querySelectorAll('.cart-timer-countdown');
      if (elements.length > 0) {
        clearInterval(checkInterval);
        this.reinitialize();
      }
    }, 100);
  
    setTimeout(() => clearInterval(checkInterval), 10000);
  }
  
  init() {
    const storedEndTime = localStorage.getItem(this.storageKey);
    const now = Date.now();

    if (storedEndTime && parseInt(storedEndTime) > now) {
      this.endTime = parseInt(storedEndTime);
    } else {

      this.endTime = now + (this.duration * 1000);
      localStorage.setItem(this.storageKey, this.endTime.toString());
    }
    
    this.updateTimer();
    

    if (this.interval) {
      clearInterval(this.interval);
    }
    
    this.interval = setInterval(() => this.updateTimer(), 1000);
  }
  
  updateTimer() {
    if (!this.timerElements || this.timerElements.length === 0) return;
    
    const now = Date.now();
    let remaining = Math.max(0, this.endTime - now);
    

    if (remaining === 0) {
      this.endTime = now + (this.duration * 1000);
      localStorage.setItem(this.storageKey, this.endTime.toString());
      remaining = this.duration * 1000;
    }
    
    const totalSeconds = Math.floor(remaining / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    const formattedTime = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
    

    this.timerElements.forEach(element => {
      element.textContent = formattedTime;
    });
  }
  
  pad(num) {
    return num.toString().padStart(2, '0');
  }
  
  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
  

  reinitialize() {
    const newElements = document.querySelectorAll('.cart-timer-countdown');
    

    if (newElements.length === 0) {
      return;
    }
    
    this.timerElements = newElements;
    const firstElement = this.timerElements[0];
    const newDuration = parseInt(firstElement.getAttribute('data-timer-duration')) || 7200;

    if (!this.duration || newDuration !== this.duration) {
      this.duration = newDuration;
      this.destroy();
      this.init();
    } else if (!this.interval) {
 
      this.init();
    }
  }
}


let cartTimer = null;

function initCartTimer() {
  if (!cartTimer) {
    cartTimer = new CartTimerBanner();
  } else {
    cartTimer.reinitialize();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initCartTimer();
  });
} else {
  initCartTimer();
}


document.addEventListener('cart:updated', () => {
  if (cartTimer) {
    setTimeout(() => {
      cartTimer.reinitialize();
    }, 100);
  }
});


const observer = new MutationObserver(() => {
  const timerElements = document.querySelectorAll('.cart-timer-countdown');
  if (timerElements.length > 0 && cartTimer) {
    cartTimer.reinitialize();
  }
});


observer.observe(document.body, {
  childList: true,
  subtree: true
});


window.initializeCartTimers = function() {
  if (cartTimer) {
    cartTimer.reinitialize();
  } else {
    initCartTimer();
  }
};

window.forceTimerUpdate = function() {
  if (cartTimer) {
    cartTimer.updateTimer();
  }
};

window.getCartTimerInstance = function() {
  return cartTimer;
};